import React from 'react';
import { LobsterMenhadenSupplySlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'menhaden-supply';
const SLUG_DB = 'menhaden-supply-db';

const DEFAULT_MENHADEN_SUPPLY = [60000, 48000, 48000];

interface MenhadenSupplyData {
  projectionYears?: number;
  projectionYearsLobster?: number;
  disabled?: boolean;
  lobsterDisabled?: boolean;
}

export default function MenhadenSupply(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<MenhadenSupplyData>(props);

  const formValues = formContext?.values?.[SLUG] as number[] | undefined;
  const formDbValues = formContext?.values?.[SLUG_DB] as number[] | undefined;
  const menhadenSupply = formValues ?? DEFAULT_MENHADEN_SUPPLY;
  const dbMenhadenSupply = formDbValues ?? menhadenSupply;
  const rawProjectionYears =
    data.projectionYears ??
    data.projectionYearsLobster ??
    formContext?.values?.['lobster-projection-years'] ??
    3;
  const projectionYears = Array.isArray(rawProjectionYears)
    ? (rawProjectionYears.length > 0 ? rawProjectionYears.length : 3)
    : (typeof rawProjectionYears === 'number' ? rawProjectionYears : 3);
  const disabled = data.disabled ?? data.lobsterDisabled ?? false;

  const handleChange = React.useCallback(
    (updatedValues: number[]) => {
      formContext?.setValue(SLUG, updatedValues);
    },
    [formContext]
  );

  return (
    <LobsterMenhadenSupplySlider
      menhadenSupply={Array.isArray(menhadenSupply) ? menhadenSupply : DEFAULT_MENHADEN_SUPPLY}
      dbMenhadenSupply={Array.isArray(dbMenhadenSupply) ? dbMenhadenSupply : []}
      projectionYears={projectionYears}
      projectionStartYear={2026}
      onChange={handleChange}
      disabled={disabled}
    />
  );
}
